const iconBusiness = require('@/assets/images/onboarding/new-user-screening/icon-business.svg')
const iconSchool = require('@/assets/images/onboarding/new-user-screening/icon-school.svg')
const iconOthers = require('@/assets/images/onboarding/new-user-screening/icon-others.svg')

export const PURPOSES = {
  Business: {
    label: 'Business',
    img: iconBusiness,
    professions: [
      {
        label: 'Trainer / L&D',
      },
      { label: 'HR' },
      { label: 'Sales' },
      { label: 'Marketing' },
      { label: 'Tech' },
      { label: 'Others' },
    ],
  },
  School: {
    label: 'School',
    img: iconSchool,
    professions: [
      {
        label: 'Professor / Lecturer',
      },
      { label: 'Teacher' },
      { label: 'Non-teaching staff' },
      { label: 'Student' },
      { label: 'Others' },
    ],
  },
  Others: {
    label: 'Others',
    img: iconOthers,
    professions: [
      {
        label: 'NGO / Charity',
      },
      { label: 'Events Organiser' },
      { label: 'Religious' },
      { label: 'Others' },
    ],
  },
}

export const MAX_STEP = 2
